export default __webpack_public_path__ + "static/media/add.12cc4f1a.png";